import { LazyLoad } from 'app/utils';

export const ProductListPage = LazyLoad(
  () => import('./index'),
  (module) => module.ProductListPage,
);
